/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/duplicate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdDuplicateCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdDuplicateProps,
  EngagementLandingPagesAppGroupIdDuplicateResult,
} from "./types";

export const postEngagementLandingPagesAppGroupIdDuplicate = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdDuplicateCacheKeys,
  (
    props: PostEngagementLandingPagesAppGroupIdDuplicateProps
  ): Promise<EngagementLandingPagesAppGroupIdDuplicateResult> => {
    const { app_group_id: appGroupId } = props;
    return fetch(`/engagement/landing_pages/${appGroupId}/duplicate`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
